var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap d-flex justify-content-center align-items-center"},[_c('div',[_c('a-empty',{attrs:{"description":_vm.noDataText}},[_vm._t("default"),_c('icon',{staticClass:"data-empty",attrs:{"slot":"image","type":"data-empty"},slot:"image"})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }